import { useState, useEffect } from 'react';
import firebaseService from '../services/firebaseService';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let unsubscribe;

    const initAuth = async () => {
      try {
        // Ikke initialiser auth automatisk - vent på brukerhandling
        unsubscribe = firebaseService.onAuthStateChange((user) => {
          setUser(user);
          setLoading(false);
        });
      } catch (error) {
        console.error('Auth initialization failed:', error);
        setError(error.message);
        setLoading(false);
      }
    };

    initAuth();

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  const signOut = async () => {
    try {
      await firebaseService.signOut();
    } catch (error) {
      setError(error.message);
    }
  };

  return {
    user,
    loading,
    error,
    signOut
  };
}